import React, { FC } from 'react'
import { CwsGridRow, CwsGridCol, CwsIcon, CwsP } from '@components/cws'

interface InterfaceProps {
  text: string
}
const InfoAlert: FC<InterfaceProps> = ({ text }) => {
  return (
    <CwsGridRow noGutter>
      <CwsGridCol col="12" className="cws-p-16 cws-bg-color-pool-light-50 rounded-[16px]">
        <CwsGridRow noGutter verticalAlign="center">
          <CwsGridCol col="auto">
            <CwsIcon color="midnight" icon="notice-info" width="18px" height="18px" />
          </CwsGridCol>
          <CwsGridCol className="cws-pl-16" col="fluid">
            <CwsP className="cws-m-0 " size="small" color="midnight">
              {text}
            </CwsP>
          </CwsGridCol>
        </CwsGridRow>
      </CwsGridCol>
    </CwsGridRow>
  )
}

export default InfoAlert
